import { render, staticRenderFns } from "./PrivacidadView.vue?vue&type=template&id=2742f696&scoped=true"
import script from "./PrivacidadView.vue?vue&type=script&lang=js"
export * from "./PrivacidadView.vue?vue&type=script&lang=js"
import style0 from "./PrivacidadView.vue?vue&type=style&index=0&id=2742f696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742f696",
  null
  
)

export default component.exports